import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Container, Button, Spinner } from 'react-bootstrap';
import { useAuth0 } from '@auth0/auth0-react';

import Gallery from './components/Gallery';
import AddFaceForm from './components/AddFaceForm';
import FaceDetails from './components/FaceDetails';
import EditFaceForm from './components/EditFaceForm';

function App() {
  const { isLoading, isAuthenticated, loginWithRedirect, logout, user } = useAuth0();

  if (isLoading) {
    return (
      <Container className="text-center my-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (!isAuthenticated) {
    return (
      <Container className="text-center my-5">
        <h2>Bad Memory</h2>
        <p>Please log in to continue.</p>
        <Button onClick={() => loginWithRedirect()}>Log In</Button>
      </Container>
    );
  }

  return (
    <div>
      <Container className="mt-3">
        <div className="d-flex justify-content-end align-items-center mb-3">
          <span className="me-3 text-muted">{user?.email}</span>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          >
            Log Out
          </Button>
        </div>
        <Routes>
          <Route path="/" element={<Gallery />} />
          <Route path="/add" element={<AddFaceForm />} />
          <Route path="/face/:id" element={<FaceDetails />} />
          <Route path="/edit/:id" element={<EditFaceForm />} />
        </Routes>
      </Container>
    </div>
  );
}

export default App;
